module.exports = __webpack_public_path__ + "assets/img/introduction_01.66b0b97f.png";